/* NOMI v20.14: cup product page behaviour.
   Gallery thumbs swap the main image; pack radios / subscribe radio update the price and the hidden selling_plan input;
   quantity stepper; sold-out state. The form still posts to /cart/add normally: no JS is required to buy. */
(function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  /* gallery */
  var main = root.querySelector('[data-pdp-main]');
  root.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-pdp-thumb]').forEach(function (b) { b.classList.toggle('is-on', b === btn); b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
      if (!main) return;
      main.classList.add('is-swapping');
      var src = btn.dataset.pdpThumb, fit = btn.dataset.fit || 'contain';
      /* v23.68: Safari gets the cup cut-outs from their .json twins (the CDN would send a PNG) */
      if (btn.dataset.pdpTwin && window.nomiB64 && window.nomiB64.safari) {
        window.nomiB64.blob(btn.dataset.pdpTwin, 'high').then(function (b) {
          main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = URL.createObjectURL(b); main.classList.toggle('is-cover', false); main.classList.toggle('is-contain', true);
          requestAnimationFrame(function () { main.classList.remove('is-swapping'); });
        }).catch(function () { main.classList.remove('is-swapping'); });
        return;
      }
      var img = new Image();
      img.onload = function () {
        main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = src; main.classList.toggle('is-cover', fit === 'cover'); main.classList.toggle('is-contain', fit !== 'cover');
        requestAnimationFrame(function () { main.classList.remove('is-swapping'); });
      };
      img.onerror = function () { main.classList.remove('is-swapping'); };
      img.src = src;
    });
  });

  /* form */
  var form = root.querySelector('#pdp-form');
  if (!form) return;
  var add = form.querySelector('[data-pdp-add]');
  var planInput = form.querySelector('[data-pdp-plan-input]');
  var planSelect = form.querySelector('[data-pdp-plan-select]');
  var modes = form.querySelectorAll('[data-pdp-mode]');

  function variant() {
    var r = form.querySelector('[data-pdp-variant]:checked') || form.querySelector('input[type=hidden][data-pdp-variant]');
    return r;
  }
  function plansFor(v) { try { return JSON.parse(v.dataset.plans || '[]'); } catch (e) { return []; } }
  function mode() { var m = form.querySelector('[data-pdp-mode]:checked'); return m ? m.value : 'once'; }

  function refresh() {
    var v = variant(); if (!v) return;
    var available = v.dataset.available === 'true';
    var plans = plansFor(v), price = v.dataset.priceMoney;
    form.querySelectorAll('.pdp-pack').forEach(function (p) { var i = p.querySelector('input'); if (i) p.classList.toggle('is-on', i.checked); });
    form.querySelectorAll('.pdp-plan').forEach(function (p) { var i = p.querySelector('input'); if (i) p.classList.toggle('is-on', i.checked); });
    if (planSelect) {
      // keep only the plans this variant allocates
      Array.prototype.forEach.call(planSelect.options, function (o) {
        var a = plans.filter(function (p) { return p.id === o.value; })[0];
        o.disabled = !a; if (a) { o.dataset.price = a.price; }
      });
      if (planSelect.selectedOptions[0] && planSelect.selectedOptions[0].disabled) {
        var next = Array.prototype.filter.call(planSelect.options, function (o) { return !o.disabled; })[0];
        if (next) planSelect.value = next.value;
      }
    }
    var subscribing = mode() === 'plan' && planSelect && planSelect.selectedOptions[0] && !planSelect.selectedOptions[0].disabled;
    if (planInput) planInput.value = subscribing ? planSelect.value : '';
    if (subscribing) price = planSelect.selectedOptions[0].dataset.price || price;
    var was = form.querySelector('[data-pdp-was]'); if (was) was.textContent = v.dataset.priceMoney;
    var pp = form.querySelector('[data-pdp-plan-price]'); if (pp && planSelect && planSelect.selectedOptions[0]) pp.textContent = planSelect.selectedOptions[0].dataset.price || '';
    form.querySelectorAll('[data-pdp-price]').forEach(function (el) { el.textContent = price; });
    var preorder = v.dataset.preorder === 'true';
    var preBox = form.querySelector('[data-pdp-preorder]');
    var notifyBox = document.querySelector('[data-pdp-notify]');
    if (add) {
      // v23.77: a sold-out pack is a free pre-order; the button stays live and opens the email form
      add.disabled = false;
      add.toggleAttribute('data-pdp-reserve', !available);
      add.classList.toggle('is-preorder', available && preorder);
      if (!available) add.textContent = add.dataset.notify || 'Notify me for batch two';
      else add.innerHTML = (preorder ? 'Pre-order · ' : 'Add to bag · ') + '<span data-pdp-price>' + price + '</span>';
    }
    if (preBox) preBox.hidden = !(available && preorder);
    if (notifyBox) notifyBox.hidden = available;
  }
  form.querySelectorAll('[data-pdp-variant]').forEach(function (i) { i.addEventListener('change', refresh); });
  form.addEventListener('submit', function (e) {
    var v = variant();
    if (v && v.dataset.available !== 'true') {
      e.preventDefault();
      var box = document.querySelector('[data-pdp-notify]');
      if (box) { box.hidden = false; box.scrollIntoView({ behavior: 'smooth', block: 'center' }); var em = box.querySelector('input[type=email]'); if (em) setTimeout(function () { em.focus({ preventScroll: true }); }, 450); }
    }
  });
  modes.forEach(function (m) { m.addEventListener('change', refresh); });
  if (planSelect) planSelect.addEventListener('change', function () { var m = form.querySelector('[data-pdp-mode][value=plan]'); if (m) m.checked = true; refresh(); });

  /* deep links: ?variant=…&selling_plan=… */
  var q = new URLSearchParams(location.search);
  if (q.get('variant')) { var vr = form.querySelector('[data-pdp-variant][value="' + q.get('variant') + '"]'); if (vr && vr.type === 'radio') vr.checked = true; }
  if (q.get('selling_plan') && planSelect) {
    var opt = Array.prototype.filter.call(planSelect.options, function (o) { return o.value === q.get('selling_plan'); })[0];
    if (opt) { planSelect.value = opt.value; var pm = form.querySelector('[data-pdp-mode][value=plan]'); if (pm) pm.checked = true; }
  }

  /* quantity */
  var qty = form.querySelector('[data-pdp-qty-input]');
  form.querySelectorAll('[data-pdp-qty]').forEach(function (b) {
    b.addEventListener('click', function () { var n = parseInt(qty.value, 10) || 1; n = Math.max(1, n + parseInt(b.dataset.pdpQty, 10)); qty.value = n; });
  });
  refresh();
})();
